import Vue from 'vue';
import Vuex from 'vuex';
import VueRouter from 'vue-router';
import axios from 'axios';
import LightBootstrap from './light-bootstrap-main';
// Plugins
import App from './App.vue';

// router setup
import routes from './routes/routes';
// store setup
import store from './store';

//Arcgis javascript api
import { loadScript } from 'esri-loader';

// vee-validate
import VeeValidate from 'vee-validate';

// vue-notify
/* import VueNotify from 'vue-notifyjs'
import 'vue-notifyjs/themes/default.css' */

// vue-wizard
import VueFormWizard from 'vue-form-wizard';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';

import JsonViewer from 'vue-json-viewer';
Vue.use(JsonViewer);

// vue maps google
import * as VueGoogleMaps from 'vue2-google-maps';
//vue tags
import { Tag } from 'element-ui';

import VuePapaParse from 'vue-papa-parse';
Vue.use(VuePapaParse);

//vue Highcharts
//import HighchartsVue from 'highcharts-vue'

// le decimos a vuex que requerimos el mudulo subscriber para nuestro store
require('@/store/subscriber');

//importar URL base de axios
import {
  AXIOS_URL,
  setLocalizeLanguage,
  setLocalizeElementUI,
} from 'src/util/Util';

//Importar libreria de internacionalización
import i18n from './i18n';

// definimos una url base para las peticiones axios de forma predeterminada
axios.defaults.baseURL = AXIOS_URL;
axios.defaults.headers.locale = 'es';

const token = localStorage.getItem('token');
if (token) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

Vue.prototype.$axios = axios;


// plugin setup
Vue.use(VueRouter);
Vue.use(LightBootstrap);
Vue.use(Vuex);
/* Vue.use(VueNotify) */
Vue.use(VeeValidate, { fieldsBagName: 'veeFields' });
Vue.use(VueFormWizard);
Vue.use(VueGoogleMaps, {
  load: {
    //key: 'AIzaSyDil3VCKyGASFzHeBmlpFNeQxVGRm7v86M'
    //key: 'AIzaSyAapwA20r-lsaKIcZw0qja_LzeICF1cnr8', //datosapcorporativas@gmail.com
    key: 'AIzaSyCkswj0mKuB61DxRemOQvOeHnhdYoZ3r3Y',
    libraries: 'visualization',
  },
});
Vue.use(Tag);
//Vue.use(HighchartsVue);
setLocalizeLanguage();
setLocalizeElementUI();

// configure router
export const router = new VueRouter({
  mode: 'history',
  routes, // short for routes: routes
  linkActiveClass: 'active',
});

// preload the ArcGIS API
const options = {
  url: 'https://js.arcgis.com/4.19/',
};

loadScript(options);

Vue.config.productionTip = false;

const VueCookie = require('vue-cookie');
Vue.use(VueCookie);

/* eslint-disable no-new */
// llamamos a la accion attempt del store a traves de dispatch para obtener
// un token en caso de existir en el local storage
store.dispatch('auth/attempt', localStorage.getItem('token')).then(() => {
  new Vue({
    el: '#app',
    store,
    i18n,
    render: (h) => h(App),
    router,
  });
});
